import { Component, OnInit, OnDestroy, OnChanges, ViewChild, ElementRef, HostListener, Inject } from "@angular/core";
import { Subscription } from 'rxjs/Subscription';
import { Router, NavigationExtras,ActivatedRoute, Params } from "@angular/router";

import { ToastrService } from 'ngx-toastr';
import { GlobalConstants } from 'src/app/pages/common/global-variables';
import { ApiService } from 'src/app/pages/common/api.service';
import { environment } from 'src/environments/environment';
import { Title } from '@angular/platform-browser';
import { AuthenticationService } from 'src/app/authentication/authentication.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { CouponModalComponent } from 'src/app/shared/components/coupon-modal/coupon-modal.component';
import { CardSwitchComponent } from 'src/app/shared/components/card-switch/card-switch.component';
import { NotEligibleModalComponent } from 'src/app/shared/components/not-eligible-modal/not-eligible-modal.component';
import { DataTransferService } from 'src/app/shared/services/common/datatransfer.service';
import { DOCUMENT } from '@angular/common';
import { PennyDropModalComponent } from "src/app/shared/components/penny-drop-modal/penny-drop-modal.component";

@Component({
  selector: "app-homepage",
  templateUrl: "./homepage.component.html",
  styleUrls: ["./homepage.component.scss"],
  providers: [GlobalConstants, ApiService]
})
export class HomepageComponent implements OnInit,OnChanges,OnDestroy {
  projectSubscription: Subscription;
  reloadSubscription: Subscription;
  authenticated_user: any = false;
  redeemOfferClicked: boolean = false;
  selectedOffer: any;
  modalRef: BsModalRef;
  merchants: any;
  offerCategories= [];
  selectedSubCategoryIndex: number = 0;
  offerBlockToShow: any = 0;
  selectedSubCategory: any;
  isMobile: boolean = false;
  isTablet: boolean = false;
  isDesktopDevice: boolean = false;
  userCardsText: any = "";
  currentUserCard: any;
  multipleCards = false;
  pageType = 'default';
  main_project_id: any;
  userEmail = '';
  emailVerified = '';
  isIslamic: any;
  contentToShow = 'home';
  tabsToShow = [
    {
        title: 'Islamic Banking Offers',
        code: 'visa-islamic-banking',
        logo_url: 'https://images.poshvine.com/icon/shopping-bag.png',
        type: 'default'
    },
    {
      title: 'Other Visa Offers',
      code: 'all',
      logo_url: 'https://assets-v2.poshvine.com/q0lm25ouholfyqxkz3ilb4kbggyz?response-content-disposition=inline%253B%2520filename%253D%2522small_business.png%2522%253B%2520filename%252A%253DUTF-8%2527%2527small_business.png&response-content-type=image%2Fpng',
      type: 'parentOffers'
    }
  ]
  @HostListener('unloaded')
  ngOnDestroy() {
    if(this.projectSubscription){
      this.projectSubscription.unsubscribe()
    }
    if(this.reloadSubscription){
      this.reloadSubscription.unsubscribe()
    }
    this.elementRef.nativeElement.remove();
  }
  removeSubscriptions(){
    if(this.projectSubscription){
      this.projectSubscription.unsubscribe()
    }
    if(this.reloadSubscription){
      this.reloadSubscription.unsubscribe()
    }
  }

  // @HostListener('window:resize', [])
  onResize() {
    if (window.innerWidth > 1024) {
      this.isDesktopDevice = true;
      this.isTablet = false;
      this.isMobile = false;
    }
    else if (window.innerWidth > 992) {
      this.isDesktopDevice = false;
      this.isTablet = true;
      this.isMobile = false;
    }
    else {
      this.isDesktopDevice = false;
      this.isTablet = false;
      this.isMobile = true;
    }
  }
  constructor(
    public router: Router,
    private route: ActivatedRoute,
    private _apiService: ApiService,
    public GlobalConstants: GlobalConstants,
    private toastr: ToastrService,
    private title: Title,
    private _auth: AuthenticationService,
    private modalService: BsModalService,
    @Inject(DOCUMENT) private document: any,
    public dataTransferService: DataTransferService,
    private elementRef: ElementRef
  ) {
    this.onResize();
    let environment_type = this.document.location.hostname.includes("sandbox") ? 'sandbox' : 'prod';
    this.main_project_id = this.GlobalConstants.data.x_header[environment_type].main_project
  }
  ngOnChanges(change) {



  }
  ngOnInit() {
    window.scrollTo(0, 0);
    this.checkPageType();
    this.checkCards();
    // this.checkOfferToRedeem();
    // this.removeSubscriptions();
    if(this.reloadSubscription){
      this.reloadSubscription = this.dataTransferService.sharedReloadEvent.subscribe(res => {
        if(res){
          console.log('reload home')
          this.checkCards();
          this.checkPageType();
          this.checkOfferToRedeem();
        }
      });
    }

  }
  checkPageType(){
    let pathname = this.document.location.pathname.split('/',3);
    this.isIslamic = pathname.includes('visa-islamic-banking') ? true : false;
    if(!this.isIslamic){
      if(pathname.length == 3 && pathname[2] == 'offers'){
        this.pageType = 'special-benefits';
        this.getProjects(pathname[1]);
      }
      else{
        this.pageType = 'default';
        this.getAllCategories();
      }
    }
    else{
      if(this.isMobile){
        this.getCategoryDetails();
      }
      else{
        this.getParentCategories();
      }

      // if(!this.route.snapshot.params.category){
      this.getProjects(pathname[1]);
      // }
    }
  }
  checkCards(){
    if (localStorage.getItem("currentUser")) {
      this.authenticated_user = true;
      if (localStorage.getItem("uc") && localStorage.getItem("uc") != 'undefined') {
        let uc = localStorage.getItem("uc");
        this._apiService.getCards().subscribe(
          (res: any) => {
            let userCards = res.data;
            if(userCards.length > 1){
              this.multipleCards = true;
              this.dataTransferService.nextUserCards(res.data);
            } else {
              this.dataTransferService.nextUserCards([res.data]);
            }
            this.currentUserCard = res.data.find((x) => { return x.id === uc })
            this.userCardsText = this.currentUserCard.attributes.display_name;
            // localStorage.setItem("userCards", JSON.stringify(res.data));

          },
          (err) => {

          }
        );
        if(localStorage.getItem("ev")){
          this.emailVerified = localStorage.getItem("ev");
        }
        else{
          this._apiService.getUserDetails().subscribe((res: any) => {
            this.userEmail = res.email;
            if(!res.email_verified || res.email_verified == 'false'){
              this.emailVerified = 'false';
              localStorage.setItem('ev','false');
            }
            else{
              this.emailVerified = 'true';
              localStorage.setItem('emailVerified','yes');
              localStorage.setItem('ev','true');
            }
          });
        }
      }

    }
    else{
      this.userCardsText = null;
      this.authenticated_user = false;
    }
  }
  currentProject: any;
  projectData: any;
  getProjects(projectCode){
    // this.removeSubscriptions();
    if(!this.projectSubscription){
      this.projectSubscription = this.dataTransferService.sharedMessage.subscribe(result => {
      // this._apiService.getProjects(this.main_project_id).subscribe(
      //   (res: any) => {
      //     if(res.data && res.data.attributes){
      //       let result = res.data.attributes;

          if(result && result.sub_projects && result.sub_projects.data && result.sub_projects.data.length > 0){
            // console.log('something')
            let hasData = false
            result.sub_projects.data.forEach(obj => {
              if(obj.attributes.code === projectCode){
                this.currentProject = obj;
                localStorage.setItem("projectId", obj.id);
                hasData = true;
                this.loadMerchants({});
                this.checkOfferToRedeem();
              }
            })
            if(!hasData){
              this.router.navigate(['']);
            }
          }
          else if(result && result.sub_projects && result.sub_projects.data && result.sub_projects.data.length == 0 ){
            this.router.navigate(['']);
          }
        // }
      });
    }

  }
  changeCurrentCard() {
    this.modalService.show(CardSwitchComponent, {
      backdrop: true,
      ignoreBackdropClick: false,
      keyboard: true
    });
  }
  showNotEligible() {
    this.modalService.show(NotEligibleModalComponent, {
      backdrop: true,
      ignoreBackdropClick: false,
      keyboard: true,
      class: 'not-eligible-modal'
    });
  }
  openCouponModal() {
    return this.modalService.show(CouponModalComponent, Object.assign({}, { class: 'redeem-coupon modal-lg modal-dialog-centered' }, {
      initialState: {
        selectedOffer: this.processSelectedOffer(this.selectedOffer)
      }
    }));
  }
  closeModal() {
    if (!this.modalRef) {
      return;
    }
    this.modalRef.hide();
    this.modalRef = null;
  }
  selectOffer(offer) {
    this.selectedOffer = offer;
  }
  redeemOffer(offer, skipChecks?) {
    if (localStorage.getItem('currentUser')) {
      if(offer.attributes.offers.data[0].attributes.claimable_by_country || skipChecks){
        if (!this.redeemOfferClicked) {
          this.redeemOfferClicked = true;
          offer['pva'] = this.currentProject.pva ? this.currentProject.pva : this.currentProject.attributes.pva;
          this.selectOffer(offer);
          this.redeemOfferClicked = false;
            this.openCouponModal().content.redeemResponseEvent.subscribe((res) => {
              if(res.response && res.response){
                if(res.response == 'success'){
                  // this.changeOfferStatus(this.selectedOffer);
                }
                else if(res.response == 'payment-needed'){
                  localStorage.setItem("offerToRedeem", JSON.stringify(this.selectedOffer));
                }
              }
          })
        }
      }
      else{
        this.showNotEligible();
      }
    }
    else {
      this.offerToRedeem = offer;
      this._auth.errorEvent.emit(true);
    }
  }
  processSelectedOffer(offer) {
    return {
      id: offer.attributes.offers.data[0].id,
      merchantLogoUrl: offer.attributes.logo_url,
      offerType: offer.attributes.offers.data[0].attributes.offer_type,
      endDate: offer.attributes.offers.data[0].attributes.end_date,
      offerTitle: offer.attributes?.offers.data[0].attributes?.title,
      merchantName: offer.attributes.name,
      redemptionUrl: offer.website ? offer.website : offer.attributes.offers.data[0].attributes.redemption_url,
      pva: offer.pva
    }
  }

  //categories
  categoriesRes: any;
  allCatAndSubCat: any;
  filteredCategories: any;
  categories: any;
  getAllCategories() {
    // this.removeSubscriptions();
    if(!this.projectSubscription){
      this.projectSubscription = this.dataTransferService.sharedMessage.subscribe(result => {

            if(result && result.id){
                this.currentProject = result;
                if (this.isMobile) {
                  this.getCategoryDetails()
                }
                else{
                  this._apiService.getCategories({}).subscribe(
                    (res: any) => {
                      this.categoriesRes = res.data.filter((item) => item.attributes.code != 'all');
                      this.allCatAndSubCat = [...this.categoriesRes.map((item) => item = item.attributes)];
                      this.filteredCategories = this.categoriesRes.filter(x => x.parent_id == null)
                      this.filteredCategories.forEach(category => {
                        category.subCategories = this.categoriesRes.filter(x => x.parent_id == category.id)
                        if (category.attributes.sub_categories) {
                          this.allCatAndSubCat.push(...category.attributes.sub_categories);
                        }
                      });
                      this.categories = this.filteredCategories;
                      this.getCategories();
                    },
                    () => {
                    }
                  );
                }
            }
      });
    }
  }
  getParentCategories() {
      this._apiService.getCategories({}, true).subscribe(
        (res: any) => {
          this.offerCategories = res.data;
          this.tabsToShow[1]['categories'] = this.offerCategories;
        },
        () => {
        }
      );
  }
  getOffers(category){
    if (this.offerCategories.length > 0) {
      this.selectedSubCategory = category;
        if (category == 'all') {

          this.getParentMerchants();
        }
        else {

          let tempCategoryIndex = this.getIndexOfK(this.offerCategories, category, 'code');
          if(tempCategoryIndex == undefined){
            this.router.navigate([this.tabsToShow[0].code, 'offers']);
            return false
          }
          else{
            this.offerBlockToShow = tempCategoryIndex ? tempCategoryIndex : 0;
            this.currentPage = 1;
            this.getParentMerchants();
          }
        }
    }
  }
  getParentMerchants(){
    this.offerTypeToShow = 'parentOffers';
    this.is_loading = true;
    var params = {
      per_page: this.perPage,
      page: this.currentPage
    }
    if (this.selectedSubCategory !== 'all' && this.offerCategories && this.offerCategories[this.offerBlockToShow] &&
      this.offerCategories[this.offerBlockToShow].attributes.code &&
      (this.offerCategories[this.offerBlockToShow].attributes.code != 'all_main')) {
      params['categories'] = this.offerCategories[this.offerBlockToShow].attributes.code
    }
    this._apiService.getMerchants(params,true).subscribe(
      (res: any) => {
        this.merchants = res.data;
        if(!res.data || res.data.length == 0){
          this.totalPages = 0;
          // this.showNotEligible()
        }
        if (res.meta) {
          this.pagination(res.meta.total_entries, res.meta.per_page);
        }
        this.is_loading = false;
        this.is_cd_loading = false;
      });
  }
  allSubcategory: any;
  mainCategories: any = [];
  getCategories() {
    this.is_loading = true;
    this.offerCategories = this.categories;
    this.allSubcategory = [];
    this.categories.forEach(x => {
      x.attributes.sub_categories.forEach(y => {
        y.category = x;
        this.allSubcategory.push(y);
      })
    });
    let allCatObj = {
      attributes: {
        code: 'all_main',
        logo_url: 'https://images.poshvine.com/logos/all+perks.png',
        name: 'ALL',
        sub_categories: [0]
      }
    }
    const cat = this.route.snapshot.paramMap.get('category');
    const subCat = this.route.snapshot.paramMap.get('sub_category');

    // this.route.params.forEach(params => {
      if (cat) {
        let tempCategoryIndex = this.getIndexOfK(this.offerCategories, cat, 'code');
        if(tempCategoryIndex < -1){
          this.router.navigate(['/']);
          return false
        }
        if (tempCategoryIndex > (this.GlobalConstants.data.desktop_category_count - 1)) {
          let tempCategory = this.offerCategories[this.GlobalConstants.data.desktop_category_count - 1];
          this.offerCategories[this.GlobalConstants.data.desktop_category_count - 1] = this.offerCategories[tempCategoryIndex];
          this.offerCategories[tempCategoryIndex] = tempCategory;
          this.offerBlockToShow = this.GlobalConstants.data.desktop_category_count - 1;
        }
        else if (subCat && this.offerCategories.length > 0) {
          var categoryIndex = this.getIndexOfK(this.offerCategories, cat, 'code');
          this.offerBlockToShow = categoryIndex ? categoryIndex : 0;
          console.log(this.offerCategories[categoryIndex].attributes.sub_categories)
          var subCategoryIndex = this.getIndexOfK(this.offerCategories[categoryIndex].attributes.sub_categories, subCat, 'code', false);
          this.selectedSubCategoryIndex = subCategoryIndex + 1;
          this.selectedSubCategory = this.offerCategories[this.offerBlockToShow].attributes.sub_categories[this.selectedSubCategoryIndex - 1];
          this.currentPage = 1;
          // this.getMerchants();
        }
        else if (this.offerCategories.length > 0) {
          if (cat == 'all') {
            this.selectedSubCategory = 'all';
          }
          else {
            var categoryIndex = this.getIndexOfK(this.offerCategories, cat, 'code');
            this.offerBlockToShow = categoryIndex ? categoryIndex : 0;
            this.selectedSubCategoryIndex = 0;
            this.currentPage = 1;
          }

        }
      }
      if(this.offerCategories && this.offerCategories.length > 0){
        this.getMerchants();
      }
      else{
        this.is_loading = false;
        this.is_cd_loading = false;
      }

    // })



  }
  is_cd_loading = true;
  getCategoryDetails() {
    this.is_cd_loading = true;
    let params = {};
    this._apiService.getCategoryDetails(params, this.isIslamic ? true : false).subscribe(
      (res: any) => {
        res.data = res.data.filter(item => item.attributes.code != 'all');
        this.offerCategories = res.data;
        this.is_cd_loading = false;
      },
      () => {
      }
    );
  }
  getIndexOfK(arr, value, key, attributes = true) {
    for (var i = 0; i < arr.length; i++) {
      var index = -2;
      if (attributes) {
        if (arr[i].attributes[key] === value) {
          index = i
        }
      }
      else {
        if (arr[i][key] === value) {
          index = i
        }
      }

      if (index > -1) {
        return i;
      }
    }
  }
  offerTypeToShow = 'default';
  is_loading: boolean = true;

  getMerchants(parent_project = false) {
    this.offerTypeToShow = 'default';
    this.is_loading = true;
    var params;

    if (this.selectedSubCategoryIndex) {
      params = {
        sub_categories: this.offerCategories[this.offerBlockToShow].id + ":" + this.offerCategories[this.offerBlockToShow].attributes.sub_categories[this.selectedSubCategoryIndex - 1].code,
        per_page: this.perPage,
        page: this.currentPage
      }
    }
    else if (this.selectedSubCategory) {
      if (this.selectedSubCategory != 'all') {
        params = {
          sub_categories: this.selectedSubCategory.parent_id + ":" + this.selectedSubCategory.code,
          per_page: this.perPage,
          page: this.currentPage,
        }
      }
      else {
        params = {
          per_page: this.perPage,
          page: this.currentPage,
          // categories: this.mainCategories
        }
      }
    }
    else {
      if (!this.offerCategories || this.offerCategories.length == 0) {
        this.merchants = [];
        this.is_loading = false;
        // return false;
      }
      params = {
        per_page: this.perPage,
        page: this.currentPage
      }
      if (this.offerCategories && this.offerCategories[this.offerBlockToShow] &&
        this.offerCategories[this.offerBlockToShow].attributes.code &&
        (this.offerCategories[this.offerBlockToShow].attributes.code != 'all_main')) {
        params.categories = this.offerCategories[this.offerBlockToShow].attributes.code
      }
    }
    this.loadMerchants(params,parent_project);
  }
  total_entries = 0;
  loadMerchants(params,parent_project = false){
    this.offerTypeToShow = 'default';
    this.is_loading = true;
    this._apiService.getMerchants(params,parent_project).subscribe(
      (res: any) => {
        this.merchants = res.data;
        this.total_entries = res?.meta?.total_entries;
        if(!res.data || res.data.length == 0){
          this.totalPages = 0;
          this.showNotEligible()
          setTimeout(()=>{
            window.location.href = "/";
            return false;
           }, 2000);
        }
        else if(res.data.length == 1 && this.currentProject && this.currentProject.attributes && this.currentProject.attributes.code){
          let merchantId = this.merchants[0].id;
          let merchant = this.currentProject.attributes.merchants.find((x) => { return x.id === merchantId })
          if(merchant && merchant.code){
            this.router.navigate([this.currentProject.attributes.code, 'offers', merchant.code]);
          }
          // if()

        }
        else if(this.currentProject && this.currentProject.attributes && this.currentProject.attributes.code && this.currentProject.attributes.merchants && this.currentProject.attributes.merchants.length > 0){
          this.merchants.forEach(obj => {
            obj['cta'] = '/'+this.currentProject.attributes.code + '/offers/' + this.currentProject.attributes.merchants.find((x) => { return x.id === obj.id }).code;
          })
        }
        if (res.meta) {
          this.pagination(res.meta.total_entries, res.meta.per_page);
        }
        this.is_loading = false;
        this.is_cd_loading = false;
      },
      () => {
        this.is_loading = false;
        this.totalPages = 0;
      }
    );
  }





  //pagination logic

  totalPages: number = 0;
  currentPage: number = 1;
  perPage: number = 18;
  pageNumStart: number = 0;
  pageNumEnd: number = 5;
  totalPageNumbers: any;
  pagination(offers_count, per_page_count?) {

    // if (per_page_count) { this.perPage = per_page_count; }
    this.totalPages = Math.ceil(offers_count / this.perPage);
    if (this.totalPages > 0) {
      this.totalPageNumbers = Array(this.totalPages).fill(0).map((x, i) => i);
      this.paginationLogic(this.currentPage);
    }
  }
  paginationLogic(i) {

    this.currentPage = i;
    if (this.currentPage == this.totalPages) {
      this.pageNumStart = this.currentPage - 5;

    }
    else if (i + 3 > this.totalPages) {
      this.pageNumStart = this.currentPage - 4;
    }
    else if (i - 2 > 0) {
      this.pageNumStart = this.currentPage - 3;
    }
    else if (i - 1 > 0) {
      this.pageNumStart = this.currentPage - 2;
    }
    else {
      this.pageNumStart = this.currentPage - 1;
    }
    if (this.pageNumStart < 0) {
      this.pageNumStart = 0;
    }
    this.pageNumEnd = this.pageNumStart + 5;
  }
  pageClicked(i, offerType) {
    if (i <= this.totalPages && i > 0) {
      this.paginationLogic(i);
      if (offerType == 'default') {
        this.getMerchants();
      } else if (offerType == 'parentOffers') {
        this.getParentMerchants();
      }
      this.scrollElementInView('offers')
    }
  }
  scrollElementInView(id) {
    setTimeout(() => {
      document.querySelector('#' + id).scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 300)
  }
  enableRouterReload(toReload){
    // if(toReload){
    //   this.router.routeReuseStrategy.shouldReuseRoute = function () {
    //       return false;
    //   }
    //   this.router.onSameUrlNavigation = 'reload';
    // }

  }
  offerToRedeem: any;
  checkOfferToRedeem(){
    this.route.queryParams.subscribe(params => {
      if(params && params['payment_verified'] && params['payment_verified'] == 'true' && localStorage.getItem("offerToRedeem")){ 
        this.offerToRedeem = JSON.parse(localStorage.getItem("offerToRedeem"));
        localStorage.removeItem('offerToRedeem');
        let qParams: Params = {};
        this.setQueryParams(qParams)
      } else if(params?.payment_verified === 'false') {     
        this.modalRef = this.modalService.show(PennyDropModalComponent, Object.assign({}, { class: 'penny-drop-modal modal-lg modal-dialog-centered'}));
        let qParams: Params = {};
        this.setQueryParams(qParams)
      }
    });
    if (this.offerToRedeem) {
      this.redeemOffer(this.offerToRedeem, true);
      this.offerToRedeem = null;
    }
  }
  setQueryParams(qParams){
    this.router.navigate([], {
        relativeTo: this.route,
        queryParams: qParams,
        queryParamsHandling: ''
    });
  }
  verifyEmail(){
    this._auth.showVerifyEmailEvent.emit(true);
  }
}
